import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { HgService } from "src/app/services/http/hg.service";
import { LaudoUnionService } from "src/app/services/http/laudo-union.service";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { UtilMasks } from "src/app/utils/util-masks";

@Component({
  selector: "app-form-novo-laudo",
  templateUrl: "./form-novo-laudo.component.html",
  styleUrls: ["./form-novo-laudo.component.scss"],
})
export class FormNovoLaudoComponent implements OnInit {
  mask = {
    placa: { mask: UtilMasks.placa, guide: false },
    documento: { mask: UtilMasks.documento, guide: false },
  };

  form = new FormGroup({
    unidadeCliente: new FormControl("", Validators.required),
    tipoVistoria: new FormControl(
      { value: "", disabled: true },
      Validators.required
    ),
    placa: new FormControl("", [Validators.minLength(7), Validators.required]),
  });

  @Output() formSubmit = new EventEmitter();

  listaUnidades: any[] = [];
  listaTipoLaudo: any[] = [];
  idConsulta: any;
  placaForm: any;
  documentoForm: any;
  params: any;

  desejaIntegrar: boolean = false;
  stateOptions: any[] = [
    { label: "Não", desejaIntegrar: false },
    { label: "Sim", desejaIntegrar: true },
  ];
  tokenHg: string = null;
  refreshTokenHg: string = null;
  entityHgId: string = null;
  instanceHgId: string = null;
  userHgId: string = null;
  emailHg: string = null;
  senhaHg: string = null;
  isAutenticadoHg: boolean = false;
  dadosIniciaisHg: any = null;
  desabilitaCriar: boolean = false;

  constructor(
    private laudoService: LaudoUnionService,
    private _hgService: HgService,
    private router: Router,
    private route: ActivatedRoute,
    private _msgService: ModalMsgService
  ) {
    this.params = this.route.snapshot.queryParams;
    this.form.patchValue(this.route.snapshot.queryParams);

    this.laudoService.getListaClienteUnidade().then((r) => {
      this.listaUnidades = r;
    });

    if (
      this.params.placa == this.form.controls.placa.value &&
      this.params.placa != ""
    ) {
      this.placaForm = this.params.placa;
      this.form.controls.placa.disable();
      this.idConsulta = this.params.consulta;
    }

    this.form.controls.unidadeCliente.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((v) => {
        if (v === "") {
          this.form.controls.tipoVistoria.patchValue("");
          this.form.controls.tipoVistoria.disable();
          this.listaTipoLaudo = [];
        } else {
          this.laudoService.getListaTipoLaudoCliente(v).then((r) => {
            this.form.controls.tipoVistoria.enable();
            this.listaTipoLaudo = r;
          });
        }
      });
  }

  ngOnInit() {}

  confirmar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    } else {
      this.formSubmit.emit(this.form.value);

      if (this.desejaIntegrar) {
        this.dadosIniciaisHg = {
          tokenHg: this.tokenHg,
          refreshTokenHg: this.refreshTokenHg,
          entityHgId: this.entityHgId,
          instanceHgId: this.instanceHgId,
          userHgId: this.userHgId,
          emailHg: this.emailHg,
          senhaHg: this.senhaHg,
        };
      } else this.dadosIniciaisHg = null;

      let dados = {
        hg: this.dadosIniciaisHg,
        tipoVistoria: this.form.value.tipoVistoria,
        unidadeCliente: this.form.value.unidadeCliente,
        placa: this.params.placa
          ? this.params.placa
          : this.form.controls.placa.value,
      };
      this.laudoService.novoLaudo(dados, this.idConsulta).then((r) => {
        if (r["status"])
          this.router.navigate(["laudo", "adicionar", r["token"], 0], {
            queryParams: { consulta: this.idConsulta },
          });
        if (!r["status"])
          this._msgService.openDialog(
            "Erro ao iniciar um novo laudo ",
            "Consulta(s) são incompatíveis com a configuração selecionada.",
            "danger",
            null
          );
      });
    }
  }

  desejaIntegrarHg() {
    this.desabilitaCriar = this.desejaIntegrar;
  }

  authHg(email, senha) {
    this._hgService
      .autenticarHg(email, senha)
      .then((dadosAuth) => {
        this.tokenHg = dadosAuth?.auth?.token;
        this.refreshTokenHg = dadosAuth?.auth?.refreshToken;
        this.entityHgId = dadosAuth?.entity?.id;
        this.instanceHgId = dadosAuth?.instance?.id;
        this.userHgId = dadosAuth?.user?.id;
        this.emailHg = email;
        this.senhaHg = senha;

        this._msgService.openDialog(
          `Sucesso!`,
          `Login efetuado com sucesso!`,
          "info"
        );

        this.isAutenticadoHg = true;
        this.desabilitaCriar = false;
        this.setStorageTokenHg();
      })
      .catch((e) => {
        localStorage.removeItem("hgDadosStorage");
        this.isAutenticadoHg = false;
        this.desabilitaCriar = true;
        this._msgService.openDialog(
          `Falha ao atenticar no ambiente da Auto Avaliar!`,
          `Tente novamente. Caso persista o erro, entre em contato com nosso suporte.`,
          "danger"
        );
      });
  }

  setStorageTokenHg() {
    localStorage.removeItem("hgDadosStorage");
    var now = moment();

    let hgDadosStorage = {
      tokenHg: this.tokenHg,
      createIn: now,
      entityHgId: this.entityHgId,
      instanceHgId: this.instanceHgId,
      userHgId: this.userHgId,
    };

    return;

    localStorage.setItem("hgDadosStorage", JSON.stringify(hgDadosStorage));
  }
}
